import React from 'react';
import cn from 'classnames';

import { Icon } from 'components/shared/Icon';

import { idxMap } from 'helpers/styleMapIdx';

import styles from './Button.module.scss';

const SIZES = {
  sm: styles.sm,
  md: styles.md,
  lg: styles.lg,
};

const MODES = {
  default: styles.defaultMode,
  icon: styles.iconMode,
};

const VARIANTS = {
  primary: styles.primary,
  secondary: styles.secondary,
  outlined: styles.outlined,
  link: styles.link,
  ghost: styles.ghost,
};

const Button = ({
  className,
  type,
  size,
  color,
  mode,
  variant,
  iconName,
  iconColor,
  children,
  startIcon,
  endIcon,
  ...restProps
}: {
  className: any;
  type: any;
  size: any;
  color: any;
  mode: any;
  variant: any;
  iconName: any;
  iconColor: any;
  children: any;
  startIcon: any;
  endIcon: any;
} & Record<string, any>) => (
  <button
    {...restProps}
    type={type}
    className={cn(
      styles.button,
      {
        [styles.withStartIcon]: startIcon,
        [styles.withEndIcon]: endIcon,
      },
      idxMap(MODES, mode),
      idxMap(VARIANTS, variant),
      idxMap(SIZES, size),
      className,
    )}
  >
    {mode === 'icon' ? (
      <Icon
        className={styles.buttonIcon}
        style={iconColor && { color: iconColor }}
        name={iconName}
      />
    ) : (
      <>
        {startIcon && <span className={styles.startIcon}>{startIcon}</span>}
        {children}
        {endIcon && <span className={styles.endIcon}>{endIcon}</span>}
      </>
    )}
  </button>
);

Button.defaultProps = {
  variant: 'primary',
  mode: 'default',
  size: 'lg',
  type: 'button',
};

export default React.memo(Button) as any;
